import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import erigonBg from '../../../static/geth-bg.png';
import {
  Hero,
  SectionTitle,
  ValidatorClientPageStyles,
} from '../ValidatorClientComponents';
import { PageTemplate } from '../../../pulsechain_components/PageTemplate';
import { Text } from '../../../pulsechain_components/Text';
import { Link } from '../../../pulsechain_components/Link';
import { Code } from '../../../pulsechain_components/Code';
import { Heading } from '../../../pulsechain_components/Heading';
import { IS_GOERLI } from '../../ConnectWallet/web3Utils';
import { IS_MAINNET } from '../../../utils/envVars';

// eslint-disable-next-line no-unused-vars
export const ErigonDetails = () => (
  <>
    <SectionTitle level={2} className="mb5">
      Erigon-Pulse
    </SectionTitle>
    <Text className="mt10">
      <FormattedMessage defaultMessage="Formerly Erigon, and before that TurboGeth, Erigon-Pulse is an PulseChain client built to enable performance optimizations." />
    </Text>
    <SectionTitle level={2} className="mb5">
      <FormattedMessage defaultMessage="Language information" />
    </SectionTitle>
    <Text className="mt10">
      <FormattedMessage defaultMessage="Erigon-Pulse is written in Go and licensed under the GNU LGPLv3." />
    </Text>
    <section>
      <SectionTitle level={2} className="mb5">
        <FormattedMessage defaultMessage="Installation" />
      </SectionTitle>
      <Text>
        <FormattedMessage
          defaultMessage="The Erigon-Pulse documentation explains how to download and
            install the client."
        />
      </Text>
      <Link
        primary
        shouldOpenNewTab
        to="https://gitlab.com/pulsechaincom/erigon-pulse"
        className="mt10"
      >
        <FormattedMessage defaultMessage="Erigon-Pulse installation documentation" />
      </Link>
    </section>
    {!IS_MAINNET && IS_GOERLI && (
      <>
        <section>
          <SectionTitle level={2} className="mb5">
            <FormattedMessage defaultMessage="Setup" />
          </SectionTitle>
          <Text className="mb20 mt10">
            <FormattedMessage defaultMessage="Make sure you do the following to get your execution client working properly." />
          </Text>
          <Heading level={3} className="mt20">
            <FormattedMessage defaultMessage="Testing on Goerli" />
          </Heading>
          <Text className="mt10">
            <FormattedMessage
              defaultMessage="Use {goerli} to sync the Goerli testnet."
              values={{
                goerli: <Code className="mt20">--chain goerli</Code>,
              }}
              description="{goerli} shows '--chain goerli' terminal command"
            />
          </Text>
          <Link
            className="mt20"
            primary
            shouldOpenNewTab
            to="https://gitlab.com/pulsechaincom/erigon-pulse/-/blob/master/README.md"
          >
            <FormattedMessage defaultMessage="Erigon-Pulse documentation" />
          </Link>
        </section>
      </>
    )}
  </>
);

export const Erigon = () => {
  const { formatMessage } = useIntl();
  return (
    <PageTemplate
      title={formatMessage(
        { defaultMessage: 'Execution Clients: {clientName}' },
        { clientName: 'Erigon-Pulse' }
      )}
    >
      <ValidatorClientPageStyles>
        <Hero imgSrc={erigonBg} />
        <ErigonDetails />
        <section>
          <SectionTitle level={2} className="mb5">
            <FormattedMessage defaultMessage="Documentation" />
          </SectionTitle>
          <Link
            shouldOpenNewTab
            primary
            to="https://gitlab.com/pulsechaincom/erigon-pulse/"
          >
            <FormattedMessage defaultMessage="Documentation on running Erigon-Pulse" />
          </Link>
        </section>
      </ValidatorClientPageStyles>
    </PageTemplate>
  );
};
